import axios from '../utils/axiosConfig';

// ✅ Get all addresses for logged-in user
export const getMyAddresses = async (accessToken) => {
  try {
    const response = await axios.get('/address/my', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching addresses:', error);
    throw error;
  }
};

// ✅ Add a new address
export const addAddress = async (addressData, accessToken) => {
  try {
    const response = await axios.post('/address/add', addressData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data.address;  // ← Extract the address object
  } catch (error) {
    console.error('Error adding address:', error);
    throw error;
  }
};

// ✅ Update an existing address
export const updateAddress = async (id, addressData, accessToken) => {
  try {
    const response = await axios.put(`/address/${id}`, addressData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data.address;  // ← Extract the updated address object
  } catch (error) {
    console.error('Error updating address:', error);
    throw error;
  }
};

// ✅ Delete address by ID
export const deleteAddress = async (id, accessToken) => {
  try {
    const response = await axios.delete(`/address/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting address:', error);
    throw error;
  }
};